import { useDate as getDateFormatter } from './useDate'

export const calculateTimezoneOffset = (date: Date, timezone: string): string => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    hour: '2-digit',
    hour12: false,
  })

  const hourPart = formatter.formatToParts(date).find((p) => p.type === 'hour')?.value
  const timezoneHour = hourPart ? parseInt(hourPart, 10) : NaN

  if (Number.isNaN(timezoneHour)) {
    return '+00:00'
  }

  const utcHour = date.getUTCHours()

  let offsetHours = timezoneHour - utcHour

  if (offsetHours > 12) offsetHours -= 24
  if (offsetHours < -12) offsetHours += 24

  if (offsetHours === 0) return '+00:00'

  const offsetSign = offsetHours >= 0 ? '+' : '-'
  return `${offsetSign}${String(Math.abs(offsetHours)).padStart(2, '0')}:00`
}

export const formatDateWithTimezone = (date: Date, timezone: string): string => {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  const hours = String(date.getUTCHours()).padStart(2, '0')
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')
  const seconds = String(date.getUTCSeconds()).padStart(2, '0')

  const offset = calculateTimezoneOffset(date, timezone)

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`
}

export const formatUtcToTimezoneOffset = (utcDateString: string, timezone: string): string => {
  const date = new Date(utcDateString)

  const formatter = getDateFormatter({
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })

  const year = formatter.getPart(date, 'year')
  const month = formatter.getPart(date, 'month')
  const day = formatter.getPart(date, 'day')
  const hour = formatter.getPart(date, 'hour')
  const minute = formatter.getPart(date, 'minute')
  const second = formatter.getPart(date, 'second')
  const offset = calculateTimezoneOffset(date, timezone)

  return `${year}-${month}-${day}T${hour}:${minute}:${second}${offset}`
}
